import { Injectable } from '@angular/core';
import { DataService } from '../../../../services/data.service';
import { tap,Observable } from 'rxjs';
import { ResponseModel } from './../../../../../shared/models/response-model.model';
import { InsertUpdateNewRateRequestModel } from './update-current-rate.model';
@Injectable({
  providedIn: 'root'
})
export class UpdateCurrentRateService {

  constructor(public service:DataService) { }

  insertUpdateNewRate(data:InsertUpdateNewRateRequestModel):Observable<ResponseModel>{
    let url = "api/app/rate/insertupdatenewrate";
    const json = JSON.stringify(data);
    
    return this.service.post(url,data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getAllNewRate():Observable<ResponseModel>{
    let url = "api/app/rate/getnewgoldrates";
    return this.service.get(url, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }

  updateUser(data):Observable<ResponseModel>{
    let url = "api/app/users/updaterecentlyusedratewebsite";
    const json =JSON.stringify(data);
    return this.service.put(url,data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }


  getUsedwebsiteurlbyuserid(userId):Observable<ResponseModel>{
    let url = `api/app/users/getrecentlyusedwebsiteurlbyuserid?userid=${userId}`;
    return this.service.get(url, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }


}
